<app-dialog
  #dialog
  [key]="dialogKey"
  [action]="dialogKey"
  [headerTheme]="'simple'"
  [maxWidth]="'560px'"
  [hideDefaultFooter]="true">
  <ng-template #title>
    <div class="committee-submit-head">
      <span class="committee-submit-head__icon" aria-hidden="true">
        <i class="pi pi-send"></i>
      </span>
      <div class="committee-submit-head__texts">
        <p class="committee-submit-head__eyebrow">Comitê de crédito</p>
        <h4 class="committee-submit-head__title">Enviar ao comitê</h4>
        <p class="committee-submit-head__subtitle">{{ companyName }}</p>
      </div>
    </div>
  </ng-template>

  <div class="committee-submit">
    @if (loading) {
      <div class="committee-submit__loading">
        <app-cog-loading-spinner [size]="48" />
        <span>Buscando quem vota neste comitê...</span>
      </div>
    } @else {
      <p class="committee-submit__notice">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        <span>{{ deadlineText }}</span>
      </p>

      @if (blockedReason) {
        <p class="committee-submit__blocked" role="alert">
          <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
          <span>{{ blockedReason }}</span>
        </p>
      }

      <app-input
        [type]="'textarea'"
        [label]="'Resumo para o comitê'"
        [placeholder]="
          'O que os sócios precisam saber para votar: tese, números principais, garantia, riscos.'
        "
        [textCenter]="false"
        [maxLength]="summaryMaxLength"
        [disabled]="sending || !!blockedReason"
        [ngModel]="summary"
        (ngModelChange)="summary = $event ?? ''" />
      <p class="committee-submit__hint">
        Opcional. O resumo entra como o primeiro comentário da discussão do comitê, que não se edita
        nem se apaga.
      </p>

      @if (votersText) {
        <p class="committee-submit__voters">{{ votersText }}</p>
      }
      @if (loadFailed) {
        <p class="committee-submit__hint">
          Não conseguimos ler a lista de votantes agora. Você ainda pode enviar: o Cognito confere a
          configuração do comitê no envio.
        </p>
      }
    }
  </div>

  <ng-template #footer>
    <div class="committee-submit-foot">
      <app-button
        [label]="'Cancelar'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="close()"></app-button>
      <app-button
        [label]="'Enviar ao comitê'"
        [icon]="'send'"
        [theme]="'darkblue'"
        [disabled]="!isFormValid()"
        [isLoading]="sending"
        [loadingText]="'Enviando...'"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
